import state from './state'

const module = {
  namespaced: true,
  state,
}

export default module

